/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import { createSelector } from 'reselect';

import {
  GET_CONSTANTS,
  GET_CONSTANTS_FAILURE,
  GET_CONSTANTS_SUCCESS,
  GET_GLOBAL_CONSTANTS,
  GET_GLOBAL_CONSTANTS_FAILURE,
  GET_GLOBAL_CONSTANTS_SUCCESS,
  UPDATE_GLOBAL_CONSTANT_SUCCESS,
  ADD_CONSTANT,
  ADD_CONSTANT_FAILURE,
  ADD_CONSTANT_SUCCESS,
  REMOVE_CONSTANT,
  REMOVE_CONSTANT_FAILURE,
  REMOVE_CONSTANT_SUCCESS,
  UPDATE_CONSTANT,
  UPDATE_CONSTANT_FAILURE,
  UPDATE_CONSTANT_SUCCESS,
} from 'constantActionCreators';
import { defaultFetchState } from 'reducerUtils';

// reducer
export const constantReducer = (state = defaultFetchState, action) => {
  switch (action.type) {
    case GET_CONSTANTS:
      return {
        ...state,
        fetchingData: true,
        fetchDataError: null,
      };
    case GET_CONSTANTS_FAILURE:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: action.payload,
      };
    case GET_CONSTANTS_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        data: keyBy(action.payload, 'name'),
      };
    case ADD_CONSTANT:
    case REMOVE_CONSTANT:
    case UPDATE_CONSTANT:
      return {
        ...state,
        updatingData: true,
        updateDataError: null,
      };
    case ADD_CONSTANT_SUCCESS:
    case REMOVE_CONSTANT_SUCCESS:
    case UPDATE_CONSTANT_SUCCESS:
      return {
        ...state,
        updatingData: false,
        fetchingData: false,
        fetchDataError: null,
        data: keyBy(action.payload, 'name'),
      };
    case ADD_CONSTANT_FAILURE:
    case REMOVE_CONSTANT_FAILURE:
    case UPDATE_CONSTANT_FAILURE:
      return {
        ...state,
        updatingData: false,
        updateDataError: action.payload,
      };

    default:
      return state;
  }
};

// reducer
export const globalConstantReducer = (state = defaultFetchState, action) => {
  switch (action.type) {
    case GET_GLOBAL_CONSTANTS:
      return {
        ...state,
        fetchingData: true,
        fetchDataError: null,
      };
    case GET_GLOBAL_CONSTANTS_FAILURE:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: action.payload,
      };
    case GET_GLOBAL_CONSTANTS_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        data: keyBy(action.payload, 'name'),
      };
    case UPDATE_GLOBAL_CONSTANT_SUCCESS:
      return {
        ...state,
        updatingData: false,
        fetchingData: false,
        fetchDataError: null,
        data: keyBy(action.payload, 'name'),
      };

    default:
      return state;
  }
};

const selectConstant = state => get(state, `constants.data`, {});

export const getAllConstants = createSelector([selectConstant], constants =>
  Object.values(constants)
);
